
/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-enable no-unused-vars*/

import { Field, reduxForm } from 'redux-form';
import { Form } from 'redux-form';
import { Row, Col, Button } from 'reactstrap';

import { FormGroup, Label, Alert } from 'reactstrap';
import { ReduxSelectField, ReduxSelectDropDownListField } from '../../components/ReduxInput';
import { isRequired } from '../../components/ReduxInput/Validators';
import submitValidate from './SubmitValidate';

let FacilityToDestinationForm = (props) => {

  const { handleSubmit, terminals, onSelectedCity, onSelectedState, onSelectedTerminal, destinations, states, zipCodes } = props; // use the handleSubmit from redux form  
  let hidden = true;
  let { error } = props;
  if (Array.isArray(error)) {
    error = error.map(err => <div key={err}>{err}</div>);
  }
  let terminalValues = terminals.map(terminal => {
    return { value: terminal._id, text: terminal.name, id: terminal.name };
  });

  return (
    <Form onSubmit={handleSubmit(submitValidate)}>
      {error ?
        <FormGroup>
          <Alert color="danger">
            {error}
          </Alert>
        </FormGroup> : null}

      <FormGroup>
        <Label >Terminal</Label>
        <Field
          placeholder={"Select Terminal"}
          id="terminal"
          name={"terminal"}
          onChange={onSelectedTerminal}
          values={terminalValues || ["Empty"]}
          component={ReduxSelectField}
          validate={isRequired}
        />
      </FormGroup>
      <Row>
        <Col>
          <FormGroup className="pr-1">
            <Label >Destination</Label>
            <Field
              id="city"
              name={"city"}
              placeholder={"Select Destination"}
              onChange={onSelectedCity}
              component={ReduxSelectDropDownListField}
              validate={isRequired}
              values={destinations}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="pr-1">
            <Label >State</Label>
            <Field
              id="state"
              name={"state"}
              placeholder={"Select State"}
              onChange={onSelectedState}
              component={ReduxSelectDropDownListField}
              validate={isRequired}
              values={states}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="pr-1">
            <Label >ZIP Codes</Label>
            <Field
              id="zip"
              name={"zip"}
              placeholder={"Select ZIP"}
              component={ReduxSelectDropDownListField}
              validate={isRequired}
              values={zipCodes}
            />
          </FormGroup>
        </Col>
      </Row>
      <hr />
      <FormGroup>
        <Button id="facilityToDestinationSubmit" type="submit" color="primary">Next</Button>{' '}
      </FormGroup>
    </Form>
  );
};


export default FacilityToDestinationForm = reduxForm({
  form: "FacilityToDestinationForm",
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true
})(FacilityToDestinationForm);



// WEBPACK FOOTER //
// ./src/components/FacilityToDestinationForm/FacilityToDestinationForm.js